import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { AxiosWrapper } from 'services/AxiosWrapper';
import { BookingManagerApiService } from 'services/BookingManagerApi';
import { ItineraryManagerApiService } from 'services/ItineraryManagerApi';
import { useNotifications } from 'hooks/useNotifications';

export const useVoucherQueries = (
  itineraryManagerApi: ItineraryManagerApiService<AxiosWrapper<AxiosInstance>>,
  bookingUuid: string | undefined,
  accessUuid: string | null
) => {
  const queryClient = useQueryClient();

  // Only enable queries if we have both bookingUuid and accessUuid
  const enabled = Boolean(bookingUuid && accessUuid);

  return {
    invalidateGetVouchersV2Instance: () =>
      queryClient.invalidateQueries({ queryKey: ['getVouchersV2Overview', 'getVouchersV2View', bookingUuid] }),
    getVouchersV2View: useQuery({
      queryKey: ['getVouchersV2View', bookingUuid, accessUuid],
      queryFn: async () => {
        if (!bookingUuid || !accessUuid) {
          return;
        }
        return itineraryManagerApi.getVouchersV2View(bookingUuid, accessUuid);
      },
      enabled,
    }),
  };
};
